import { render, staticRenderFns } from "./vue-particles.vue?vue&type=template&id=1d508bdc"
import script from "./vue-particles.vue?vue&type=script&lang=js"
export * from "./vue-particles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports